import { getCookie } from '@polestar/shared-front-myorder';

const impersonationId = getCookie('impersonation_id');
const impersonationToken = sessionStorage?.getItem('impersonation.id_token');
const isImpersonating = !!(impersonationId && impersonationToken);
const user = sessionStorage && JSON.parse(sessionStorage.getItem('user'));

export const authHelper = {
  isImpersonating,
  impersonationId,
  impersonationToken,
  user
};
